import React, { createContext, useContext, useEffect, useState } from 'react';
import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000/api';

// Shown until the admin-managed values arrive, and if the request fails.
export const FALLBACK_HOURS = {
  title: { en: "Doctor's Working Hours:", ar: 'أوقات دوام الدكتورة :' },
  days: { en: 'Sunday - Monday - Wednesday only', ar: 'الأحد - الأثنين - الأربعاء فقط' },
  time: { en: 'From 1:00 PM to 5:00 PM', ar: 'من الساعة ١ مساءً حتى ٥ مساءً' }
};

export const FALLBACK_CONTACT = {
  phone: '',
  phoneDisplay: '',
  whatsapp: '',
  email: '',
  instagram: '',
  snapchat: '',
  tiktok: '',
  twitter: ''
};

export const FALLBACK_LOCATION = {
  address: { en: 'Riyadh, Saudi Arabia', ar: 'الرياض، المملكة العربية السعودية' },
  mapUrl: '',
  mapEmbedUrl: ''
};

const SiteInfoContext = createContext({
  workingHours: FALLBACK_HOURS,
  contact: FALLBACK_CONTACT,
  location: FALLBACK_LOCATION
});

export const useWorkingHours = () => useContext(SiteInfoContext);
export const useSiteInfo = () => useContext(SiteInfoContext);

// One fetch for the whole app - the top banner, the contact page and the footer share it.
export const WorkingHoursProvider = ({ children }) => {
  const [siteInfo, setSiteInfo] = useState({
    workingHours: FALLBACK_HOURS,
    contact: FALLBACK_CONTACT,
    location: FALLBACK_LOCATION
  });

  useEffect(() => {
    let cancelled = false;
    axios.get(`${API_URL}/site/footer`)
      .then(res => {
        if (cancelled || !res.data) return;
        setSiteInfo({
          workingHours: res.data.workingHours || FALLBACK_HOURS,
          contact: { ...FALLBACK_CONTACT, ...(res.data.contact || {}) },
          location: { ...FALLBACK_LOCATION, ...(res.data.location || {}) }
        });
      })
      .catch(() => {
        // Keep the fallbacks - the banner must still render.
      });
    return () => { cancelled = true; };
  }, []);

  return (
    <SiteInfoContext.Provider value={siteInfo}>
      {children}
    </SiteInfoContext.Provider>
  );
};
